import { CoreBancarioModulos } from './CoreBancarioModulos';
export default CoreBancarioModulos;
